import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';

type ContractStatusProps = {
  statusCode: Model.Enum.ContractStatusCode;
};
export default function ContractStatus({ statusCode }: ContractStatusProps) {
  const { lang } = getLocales();
  return (
    <span
      style={
        statusCode === 'CANCELED_REFUND' ||
        statusCode === 'CANCELED_PR_REFUND' ||
        statusCode === 'CANCELED_REFUND / PR REFUND' ||
        statusCode === 'CANCELED_VOID'
          ? { color: Theme.Color.error, fontWeight: 'bold' }
          : statusCode === 'PAID_ACTIVE'
            ? { color: Theme.Color.success, fontWeight: 'bold' }
            : undefined
      }
    >
      {statusCode ? lang[statusCode]?.replace(/_/g, ' - ') : lang.noContractDefined}
    </span>
  );
}
